import React, { useContext } from 'react';
import styled from 'styled-components';
import { ReactComponent as BaseSettingAccountIcon } from '@ubeya/shared-web/assets/settingAccount.svg';
import { flex, FlexColumnCenter, Loader as LoaderBase } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled(FlexColumnCenter)`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: ${({ theme }) => theme.colors.disabled} !important;
  z-index: 1;
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.black};
  ${flex}
`;

const SettingAccountIcon = styled(BaseSettingAccountIcon)`
  margin-top: 58px;
`;

const Loader = styled(LoaderBase)`
  margin-top: 50px;
`;

const SettingAccountLoader = () => {
  const { t } = useContext(ConfigContext);
  const text = t('settingUpAccount');

  return (
    <Wrapper>
      <Title>{text}</Title>

      <SettingAccountIcon />
      <Loader />
    </Wrapper>
  );
};

export default SettingAccountLoader;
